const { STATUSES } = require('./exchanges');
const { cleanDocument, documentHTML, documentText } = require('./mailDocument');

const SENDER = 'ices-noreply@ices.fr';
const RECIPIENTS = ['cloquet@ices.fr', 'etudiant@ices.fr', 'pfrottier@ices.fr', 'acousin@ices.fr', 'mbarittaud@ices.fr'];
const PROFILES = { Inscription: 'Inscription', Candidature: 'Candidature', Echange: 'Échange' };
const EVENTS = { created: 'Création du dossier', salesforce: 'Envoi du dossier à Salesforce' };
const VARIABLES = {
  prenom: 'Prénom de l’étudiant', nom: 'Nom de l’étudiant', email: 'Adresse de l’étudiant',
  profil: 'Profil du dossier', formation: 'Formation', niveau: 'Niveau', session: 'Session',
  statut: 'Nouveau statut', ancien_statut: 'Ancien statut', lien_dossier: 'Lien personnel du dossier'
};
const SAMPLE = { prenom: 'Camille', nom: 'Martin', email: 'camille@example.com', profil: 'Inscription',
  formation: 'Licence de droit', niveau: 'Licence 1', session: '2026–2027', statut: 'Envoyé',
  ancien_statut: 'En cours', lien_dossier: 'https://inscriptions.ices.fr/?tkn=exemple' };
const escapeHtml = value => String(value ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
function interpolate(source, values, html = false) {
  return String(source || '').replace(/{{\s*([a-z_]+)\s*}}/g, (_, key) => html ? escapeHtml(values[key]) : String(values[key] ?? ''));
}
function render(template, values) {
  const subject = interpolate(template.subject, values).replace(/[\r\n]/g, ' ');
  if (template.format === 'rich') {
    const document = cleanDocument(template.document);
    return { subject, text: interpolate(documentText(document), values), html: documentHTML(document, values) };
  }
  const text = interpolate(template.text, values);
  const html = template.format === 'html' ? interpolate(template.html, values, true)
    : '<!doctype html><html><body><div style="font-family:Arial,sans-serif;font-size:16px;line-height:1.6;white-space:pre-wrap">' + escapeHtml(text) + '</div></body></html>';
  return { subject, text, html };
}
function validateTemplate(input) {
  if (!input || typeof input !== 'object') throw new Error('Modèle invalide.');
  const string = (key, max, required = true) => {
    if (typeof input[key] !== 'string' || input[key].length > max || (required && !input[key].trim())) throw new Error(`Champ ${key} manquant ou trop long (maximum ${max} caractères).`);
    return input[key].trim();
  };
  if (!Object.prototype.hasOwnProperty.call(PROFILES, input.profile)) throw new Error('Choisissez un profil valide.');
  if (!['text', 'html', 'rich'].includes(input.format)) throw new Error('Format du message invalide.');
  if (typeof input.enabled !== 'boolean' || typeof input.toStudent !== 'boolean') throw new Error('Activation ou destinataire invalide.');
  if (!Array.isArray(input.recipients) || input.recipients.some(email => !RECIPIENTS.includes(email))) throw new Error('Destinataire non autorisé.');
  if (!input.toStudent && !input.recipients.length) throw new Error('Sélectionnez au moins un destinataire.');
  const triggers = input.profile === 'Echange' ? Object.keys(STATUSES).map(s => `status:${s}`) : Object.keys(EVENTS);
  if (!Array.isArray(input.triggers) || !input.triggers.length || input.triggers.some(event => !triggers.includes(event)) || (input.profile !== 'Echange' && input.triggers.length !== 1)) throw new Error('Choisissez une étape valide pour ce profil.');
  const result = { name: string('name', 150), profile: input.profile, enabled: input.enabled,
    format: input.format, subject: string('subject', 250), text: input.format === 'rich' ? '' : string('text', 50000, input.format === 'text'),
    html: input.format === 'rich' ? '' : string('html', 150000, input.format === 'html'), toStudent: input.toStudent,
    recipients: [...new Set(input.recipients)], triggers: [...new Set(input.triggers)] };
  if (input.format === 'rich') {
    result.document = cleanDocument(input.document);
    result.text = documentText(result.document);
    if (result.text.length > 50000) throw new Error('Le message dépasse 50 000 caractères.');
    result.html = '';
    if (!result.text && !JSON.stringify(result.document).includes('\"type\":\"image\"')) throw new Error('Ajoutez du texte ou une image au message.');
    // Limiter le HTML hors images pour éviter les messages tronqués par les messageries.
    const html = documentHTML(result.document, SAMPLE).replace(/data:image\/(?:png|jpeg|gif);base64,[A-Za-z0-9+/=]+/g, 'cid:image');
    if (html.length > 90000) throw new Error('Le modèle contient trop de mise en forme. Simplifiez-le pour éviter un e-mail tronqué.');
  }
  if (/[\r\n]/.test(result.subject)) throw new Error('L’objet doit tenir sur une ligne.');
  for (const source of [result.subject, result.text, result.html, ...(result.document ? [JSON.stringify(result.document)] : [])]) {
    for (const match of source.matchAll(/{{(.*?)}}/gs)) {
      if (!Object.prototype.hasOwnProperty.call(VARIABLES, match[1].trim())) throw new Error(`Variable inconnue : ${match[0]}`);
    }
  }
  return result;
}
module.exports = { SENDER, RECIPIENTS, PROFILES, EVENTS, VARIABLES, SAMPLE, render, validateTemplate };
